/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const meetingProductSyncActionsDemoContent = [
  { type: 'heading', level: 2, text: 'Must ship (notes)' },
  {
    type: 'checklist',
    items: [
      { text: 'Search + new note below filters', checked: true },
      { text: 'Meeting @time header when typing starts', checked: true },
      { text: 'Sidebar selection sync with detail pane', checked: true },
      { text: 'Rich formatted bodies for meeting notes', checked: true },
      { text: 'Offline draft recovery', checked: false },
    ],
  },
  { type: 'heading', level: 2, text: 'Action items' },
  {
    type: 'checklist',
    items: [
      { text: 'Alex — launch timeline doc in Notion by Monday', checked: false },
      { text: 'Jordan — design review deck (flows + empty states)', checked: false },
      { text: 'Sam — telemetry for transcribe clicks + note creation', checked: false },
      { text: 'You — recap in #product-updates with recording link', checked: false },
      { text: 'Taylor — vendor follow-up on transcript quality', checked: false },
    ],
  },
  { type: 'heading', level: 2, text: 'Open questions' },
  {
    type: 'bullets',
    items: [
      'Do we show participant avatars before first transcript chunk?',
      'Should older meetings use 24h time in the header on non-today dates?',
      'Export to PDF — in scope for pilot or post-GA?',
    ],
  },
  {
    type: 'quote',
    text: 'Sia summary: consensus on folder-first inbox and a May 28 pilot; main risk is calendar + export scope expanding before GA.',
  },
]
